import { useState } from 'react';
import { Link } from 'react-router-dom';
import ImageCarousel from '../../../components/feature/ImageCarousel';

interface ProductModel {
  id: string;
  name: string;
  size: string;
  area: string;
  capacity: string;
  price: string;
  image: string;
  features: string[];
  description: string;
  carouselImages: {
    interior: string;
    floorPlan: string;
    exterior: string;
  };
  materialList: {
    mainFrame: string;
    exteriorWall: string[];
    glass: string[];
    wall: string[];
    floor: string;
    insulation: string;
  };
  sellingPoints: string;
}

export default function ProductModels() {
  const [selectedProduct, setSelectedProduct] = useState<ProductModel | null>(null);

  const models: ProductModel[] = [
    {
      id: 'a1',
      name: 'A6 Compact',
      size: '5.6m × 2.25m × 2.4m',
      area: '12.60㎡',
      capacity: '2-4 people',
      price: 'POA',
      image: '/images/e6379fec28de.webp',
      features: [
        'Perfect for solo entrepreneurs',
        'Integrated desk & storage',
        'Energy-efficient LED lighting',
        'Smart climate control'
      ],
      description: 'Ideal compact workspace solution',
      carouselImages: {
        interior: '/images/68e167f691a1.webp',
        floorPlan: '/images/2216d27a5784.webp',
        exterior: '/images/21c9f7978b61.webp'
      },
      materialList: {
        mainFrame: '4mm thickness thermal mirror zinc',
        exteriorWall: ['2.5mm thick aviation aluminium plate', 'Double layer carbon paint'],
        glass: ['5+15A+5 hollow heat insulation tempered glass', 'Heat insulation carbon paint'],
        wall: ['Standard color integrated wall panel or', 'High-standard color integrated wall panel'],
        floor: 'Environmental protection stone plastic floor',
        insulation: '100mm polyurethane insulation layer'
      },
      sellingPoints: 'Plug-and-play design requires no foundation work. Simply place on level ground and connect utilities. Pre-wired electrical systems and integrated plumbing make installation effortless. Perfect for temporary or permanent installations with minimal site preparation.'
    },
    {
      id: 'a2',
      name: 'A9 Standard',
      size: '9m × 2.25m × 2.4m',
      area: '20.25㎡',
      capacity: '4-6 people',
      price: 'POA',
      image: '/images/c28c289e3bc5.webp',
      features: [
        'Spacious meeting area',
        'Separate work zones',
        'Premium sound insulation',
        'Advanced HVAC system'
      ],
      description: 'Versatile workspace for small teams',
      carouselImages: {
        interior: '/images/4373686ea26b.webp',
        floorPlan: '/images/a3a16fe1801d.webp',
        exterior: '/images/edafa2d8532a.webp'
      },
      materialList: {
        mainFrame: '4mm thickness thermal mirror zinc',
        exteriorWall: ['2.5mm thick aviation aluminium plate', 'Double layer carbon paint'],
        glass: ['5+15A+5 hollow heat insulation tempered glass', 'Heat insulation carbon paint'],
        wall: ['Standard color integrated wall panel or', 'High-standard color integrated wall panel'],
        floor: 'Environmental protection stone plastic floor',
        insulation: '100mm polyurethane insulation layer'
      },
      sellingPoints: 'Revolutionary modular construction eliminates foundation requirements. Arrives 90% pre-assembled with integrated utilities. Set up in hours, not weeks. Relocatable design means you can move your office whenever needed. Perfect for growing businesses requiring flexible workspace solutions.'
    },
    {
      id: 'a3',
      name: 'A12 Executive',
      size: '11.5m × 2.25m × 2.4m',
      area: '25.87㎡',
      capacity: '6-8 people',
      price: 'POA',
      image: '/images/8b41f7de70a0.webp',
      features: [
        'Executive office suite',
        'Conference room',
        'Kitchenette & restroom',
        'Premium finishes'
      ],
      description: 'Premium workspace for executives',
      carouselImages: {
        interior: '/images/8b8796697489.webp',
        floorPlan: '/images/8b8796697489.webp',
        exterior: '/images/7cf019a46340.webp'
      },
      materialList: {
        mainFrame: '4mm thickness thermal mirror zinc',
        exteriorWall: ['2.5mm thick aviation aluminium plate', 'Double layer carbon paint'],
        glass: ['5+15A+5 hollow heat insulation tempered glass', 'Heat insulation carbon paint'],
        wall: ['Standard color integrated wall panel or', 'High-standard color integrated wall panel'],
        floor: 'Environmental protection stone plastic floor',
        insulation: '100mm polyurethane insulation layer'
      },
      sellingPoints: 'Premium plug-and-play executive solution with zero foundation needs. Advanced leveling system adapts to any terrain. All utilities pre-installed and tested. Smart building technology integrated. Deploy your executive office in a single day with minimal disruption. Ideal for corporate campuses, remote sites, or temporary headquarters.'
    },
    {
      id: 'a4',
      name: 'A-S Elite',
      size: '5.6m × 2.2m × 2.4m',
      area: '12.3㎡',
      capacity: '2-3 people',
      price: 'FROM $48,620',
      image: '/images/65a595c1c44c.webp',
      features: [
        'Premium compact design',
        'Enhanced insulation system',
        'High-end interior finishes',
        'Advanced ventilation'
      ],
      description: 'Elite compact workspace solution',
      carouselImages: {
        interior: '/images/cf78618df65a.webp',
        floorPlan: '/images/5e1c98756dff.webp',
        exterior: '/images/3b360a029ea6.webp'
      },
      materialList: {
        mainFrame: 'Galvanized steel frame structure 5.0',
        exteriorWall: ['Aluminium alloy aluminium veneer 2.0', 'Metal fluorocarbon paint baking paint'],
        glass: ['6+15A+6 hollow Low E tempered glass'],
        wall: ['Advanced environmentally friendly carbon crystal panel'],
        floor: '6cm SPC premium stone crystal locking floor',
        insulation: '100mm polyurethane insulation layer'
      },
      sellingPoints: 'Elite series compact design with premium materials and enhanced features. Perfect for professionals seeking a high-quality workspace solution with superior comfort and style. Quick installation with minimal site requirements.'
    },
    {
      id: 'a5',
      name: 'A-P3 Elite',
      size: '5.6m × 3.3m × 3.2m',
      area: '18㎡',
      capacity: '3-4 people',
      price: 'FROM $51,040',
      image: '/images/20363215da46.webp',
      features: [
        'Elevated ceiling height',
        'Spacious interior layout',
        'Premium glass system',
        'Enhanced natural lighting'
      ],
      description: 'Premium elevated workspace',
      carouselImages: {
        interior: '/images/f779c711ffe9.webp',
        floorPlan: '/images/5e1c98756dff.webp',
        exterior: '/images/29d1735260e9.webp'
      },
      materialList: {
        mainFrame: 'Galvanized steel frame structure 5.0',
        exteriorWall: ['Aluminium alloy aluminium veneer 2.0', 'Metal fluorocarbon paint baking paint'],
        glass: ['6+15A+6 hollow Low E tempered glass'],
        wall: ['Advanced environmentally friendly carbon crystal panel'],
        floor: '6cm SPC premium stone crystal locking floor',
        insulation: '100mm polyurethane insulation layer'
      },
      sellingPoints: 'Premium elevated design with enhanced ceiling height for a more spacious feel. Superior natural lighting and ventilation. Ideal for small teams requiring a comfortable and professional workspace environment.'
    },
    {
      id: 'a6',
      name: 'A-P5 Elite',
      size: '9.5m × 3.3m × 3.2m',
      area: '31㎡',
      capacity: '4-6 people',
      price: 'FROM $53,130',
      image: '/images/6a50655936e4.webp',
      features: [
        'Extended workspace area',
        'Multiple work zones',
        'Premium climate control',
        'Professional meeting space'
      ],
      description: 'Extended elite workspace solution',
      carouselImages: {
        interior: '/images/ai-expansive-luxury-office-interior-with-hi-e2012f.webp',
        floorPlan: '/images/f3705140c0dc.webp',
        exterior: '/images/e1fa3474346d.webp'
      },
      materialList: {
        mainFrame: 'Galvanized steel frame structure 5.0',
        exteriorWall: ['Aluminium alloy aluminium veneer 2.0', 'Metal fluorocarbon paint baking paint'],
        glass: ['6+15A+6 hollow Low E tempered glass'],
        wall: ['Advanced environmentally friendly carbon crystal panel'],
        floor: '6cm SPC premium stone crystal locking floor',
        insulation: '100mm polyurethane insulation layer'
      },
      sellingPoints: 'Extended elite workspace with multiple functional zones. Perfect for growing teams requiring separate areas for collaboration and focused work. Premium features throughout with enhanced comfort and productivity.'
    },
    {
      id: 'a7',
      name: 'A-P7 Elite',
      size: '11.5m × 3.3m × 3.2m',
      area: '38㎡',
      capacity: '6-8 people',
      price: 'FROM $62,150',
      image: '/images/f31cf4a3e2cc.webp',
      features: [
        'Maximum workspace capacity',
        'Executive meeting room',
        'Multiple functional zones',
        'Premium amenities included'
      ],
      description: 'Ultimate elite workspace solution',
      carouselImages: {
        interior: '/images/ai-grand-luxury-office-interior-with-high-c-17d927.webp',
        floorPlan: '/images/6d84c38942df.webp',
        exterior: '/images/555cd63ffff0.webp'
      },
      materialList: {
        mainFrame: 'Galvanized steel frame structure 5.0',
        exteriorWall: ['Aluminium alloy aluminium veneer 2.0', 'Metal fluorocarbon paint baking paint'],
        glass: ['6+15A+6 hollow Low E tempered glass'],
        wall: ['Advanced environmentally friendly carbon crystal panel'],
        floor: '6cm SPC premium stone crystal locking floor',
        insulation: '100mm polyurethane insulation layer'
      },
      sellingPoints: 'Ultimate elite workspace solution with maximum capacity and premium features. Includes executive meeting room, multiple work zones, and full amenities. Perfect for established teams requiring a comprehensive professional workspace environment.'
    },
    {
      id: 'a8',
      name: 'A-P8 Double Layer',
      size: '8.0m × 3.3m × 3.2m',
      area: '52㎡',
      capacity: '8-10 people',
      price: 'From $99,000',
      image: '/images/5c4a47384fa7.webp',
      features: [
        'Two-level workspace design',
        'Separate floors for different functions',
        'Enhanced vertical space utilization',
        'Premium double-layer construction'
      ],
      description: 'Innovative double-layer workspace',
      carouselImages: {
        interior: '/images/51043bb45990.webp',
        floorPlan: '/images/61b68bc95a8a.webp',
        exterior: '/images/5c4a47384fa7.webp'
      },
      materialList: {
        mainFrame: 'Galvanized steel frame structure 5.0',
        exteriorWall: ['Aluminium alloy aluminium veneer 2.0', 'Metal fluorocarbon paint baking paint'],
        glass: ['6+15A+6 hollow Low E tempered glass'],
        wall: ['Advanced environmentally friendly carbon crystal panel'],
        floor: '6cm SPC premium stone crystal locking floor',
        insulation: '100mm polyurethane insulation layer'
      },
      sellingPoints: 'Revolutionary double-layer design maximises vertical space efficiency. Two separate floors provide distinct functional zones for work and meetings. Premium construction with enhanced structural integrity. Ideal for businesses requiring maximum space utilization in a compact footprint. Quick installation with integrated staircase and utilities.'
    }
  ];

  const openModal = (product: ProductModel) => {
    setSelectedProduct(product);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedProduct(null);
    document.body.style.overflow = 'unset';
  };

  const getCarouselImages = (product: ProductModel) => {
    return [
      { url: product.carouselImages.interior, label: 'Interior View' },
      { url: product.carouselImages.floorPlan, label: 'Floor Plan' },
      { url: product.carouselImages.exterior, label: 'Exterior View' }
    ];
  };

  return (
    <section id="models" className="py-16 sm:py-20 lg:py-24 bg-black relative w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16 w-full">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-gray-500/20 border border-gray-400/30 rounded-full mb-6">
            <i className="ri-building-line text-gray-300"></i>
            <span className="text-gray-300 text-sm uppercase tracking-wider">Available Models</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6">
            Choose Your Perfect <span className="text-gray-300">Workspace</span>
          </h2>
          <p className="text-base sm:text-lg text-gray-400 max-w-3xl mx-auto">
            Three versatile models designed to meet different business needs and team sizes
          </p>
        </div>

        {/* Product Cards Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 w-full">
          {models.map((model) => (
            <div
              key={model.id}
              onClick={() => openModal(model)}
              className="bg-gray-900/40 backdrop-blur-xl border border-gray-500/20 rounded-2xl overflow-hidden hover:border-gray-400/40 transition-all hover:shadow-[0_0_30px_rgba(148,163,184,0.2)] cursor-pointer group w-full"
            >
              {/* Product Image */}
              <div className="relative w-full h-64 overflow-hidden">
                <img
                  src={model.image}
                  alt={model.name}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 bg-gray-300/90 backdrop-blur-sm px-3 py-1 rounded-full">
                  <span className="text-black text-sm font-semibold">{model.price}</span>
                </div>
              </div>

              {/* Product Info */}
              <div className="p-6 w-full">
                <h3 className="text-2xl font-bold text-white mb-3">{model.name}</h3>
                <p className="text-gray-400 text-sm mb-4">{model.description}</p>

                {/* Specs Grid */}
                <div className="grid grid-cols-3 gap-3 mb-6 w-full">
                  <div className="text-center p-3 bg-gray-800/40 rounded-lg">
                    <div className="text-xs text-gray-400 mb-1">Size</div>
                    <div className="text-sm font-semibold text-white break-words">{model.size}</div>
                  </div>
                  <div className="text-center p-3 bg-gray-800/40 rounded-lg">
                    <div className="text-xs text-gray-400 mb-1">Area</div>
                    <div className="text-sm font-semibold text-white">{model.area}</div>
                  </div>
                  <div className="text-center p-3 bg-gray-800/40 rounded-lg">
                    <div className="text-xs text-gray-400 mb-1">Capacity</div>
                    <div className="text-sm font-semibold text-white break-words">{model.capacity}</div>
                  </div>
                </div>

                {/* Features List */}
                <div className="space-y-2 mb-6 w-full">
                  {model.features.map((feature, index) => (
                    <div key={index} className="flex items-center gap-2">
                      <i className="ri-checkbox-circle-fill text-gray-300 text-sm flex-shrink-0"></i>
                      <span className="text-sm text-gray-400">{feature}</span>
                    </div>
                  ))}
                </div>

                {/* Click to View More */}
                <div className="text-center py-3 bg-gray-800/40 rounded-lg border border-gray-500/20 group-hover:border-gray-400/40 transition-all">
                  <span className="text-gray-300 text-sm font-medium">Click to View Details</span>
                  <i className="ri-arrow-right-line text-gray-300 ml-2"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Customisation Note */}
        <div className="mt-16 bg-gradient-to-br from-gray-500/10 to-transparent border border-gray-400/30 rounded-3xl p-8 lg:p-12 text-center">
          <div className="w-20 h-20 bg-gray-500/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <i className="ri-settings-3-line text-5xl text-gray-300"></i>
          </div>
          <h3 className="text-2xl font-medium mb-4 text-white">Custom Configurations Available</h3>
          <p className="text-gray-400 max-w-2xl mx-auto mb-6">
            All models can be customised with different finishes, layouts, and additional features to match your brand and requirements.
          </p>
          <Link 
            to="/contact"
            className="inline-block px-8 py-3 bg-transparent border-2 border-gray-300 text-gray-300 text-base font-medium rounded-full hover:bg-gray-300/10 transition-all whitespace-nowrap cursor-pointer"
          >
            Discuss Customisation
          </Link>
        </div>
      </div>

      {/* Modal */}
      {selectedProduct && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          style={{ backdropFilter: 'blur(8px)', backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
          onClick={closeModal}
        >
          <div
            className="bg-gray-900/95 border border-gray-500/30 rounded-3xl max-w-6xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div className="sticky top-0 bg-gray-900/95 backdrop-blur-xl border-b border-gray-500/20 p-6 flex items-center justify-between z-10">
              <div>
                <h3 className="text-2xl sm:text-3xl font-bold text-white">{selectedProduct.name}</h3>
                <p className="text-gray-400 text-sm mt-1">{selectedProduct.description}</p>
              </div>
              <button
                onClick={closeModal}
                className="w-10 h-10 flex items-center justify-center bg-gray-800/60 hover:bg-gray-700/60 rounded-full transition-all cursor-pointer"
              >
                <i className="ri-close-line text-2xl text-white"></i>
              </button>
            </div>

            {/* Modal Content */}
            <div className="p-6 sm:p-8 space-y-8">
              {/* Image Carousel - New Component */}
              <ImageCarousel 
                images={getCarouselImages(selectedProduct)} 
                className="h-96"
                accentColor="gray"
              />

              {/* Material List */}
              <div className="bg-gray-800/40 border border-gray-500/20 rounded-2xl p-6 sm:p-8">
                <h4 className="text-xl font-bold text-white mb-6 flex items-center gap-3">
                  <i className="ri-file-list-3-line text-gray-300"></i>
                  Technical Specifications - Material List
                </h4>
                <div className="space-y-5">
                  {/* Main Frame */}
                  <div className="p-4 bg-gray-900/40 rounded-xl">
                    <div className="text-gray-300 font-semibold text-sm mb-2">Main Frame:</div>
                    <div className="text-gray-400 text-sm">{selectedProduct.materialList.mainFrame}</div>
                  </div>

                  {/* Exterior Wall */}
                  <div className="p-4 bg-gray-900/40 rounded-xl">
                    <div className="text-gray-300 font-semibold text-sm mb-2">Exterior Wall:</div>
                    <div className="space-y-1">
                      {selectedProduct.materialList.exteriorWall.map((item, index) => (
                        <div key={index} className="text-gray-400 text-sm">{item}</div>
                      ))}
                    </div>
                  </div>

                  {/* Glass */}
                  <div className="p-4 bg-gray-900/40 rounded-xl">
                    <div className="text-gray-300 font-semibold text-sm mb-2">Glass:</div>
                    <div className="space-y-1">
                      {selectedProduct.materialList.glass.map((item, index) => (
                        <div key={index} className="text-gray-400 text-sm">{item}</div>
                      ))}
                    </div>
                  </div>

                  {/* Wall */}
                  <div className="p-4 bg-gray-900/40 rounded-xl">
                    <div className="text-gray-300 font-semibold text-sm mb-2">Wall:</div>
                    <div className="space-y-1">
                      {selectedProduct.materialList.wall.map((item, index) => (
                        <div key={index} className="text-gray-400 text-sm">{item}</div>
                      ))}
                    </div>
                  </div>

                  {/* Floor */}
                  <div className="p-4 bg-gray-900/40 rounded-xl">
                    <div className="text-gray-300 font-semibold text-sm mb-2">Floor:</div>
                    <div className="text-gray-400 text-sm">{selectedProduct.materialList.floor}</div>
                  </div>

                  {/* Insulation */}
                  <div className="p-4 bg-gray-900/40 rounded-xl">
                    <div className="text-gray-300 font-semibold text-sm mb-2">Insulation:</div>
                    <div className="text-gray-400 text-sm">{selectedProduct.materialList.insulation}</div>
                  </div>
                </div>
              </div>

              {/* Selling Points */}
              <div className="bg-gradient-to-r from-gray-500/20 to-gray-600/20 border border-gray-400/30 rounded-2xl p-6">
                <h4 className="text-xl font-bold text-white mb-4 flex items-center gap-3">
                  <i className="ri-lightbulb-flash-line text-gray-300"></i>
                  Plug & Play Installation
                </h4>
                <p className="text-gray-300 text-sm leading-relaxed">
                  {selectedProduct.sellingPoints}
                </p>
              </div>

              {/* Basic Info */}
              <div className="grid grid-cols-3 gap-4">
                <div className="bg-gray-800/40 border border-gray-500/20 rounded-xl p-4 text-center">
                  <i className="ri-ruler-line text-2xl text-gray-300 mb-2"></i>
                  <div className="text-xs text-gray-400 mb-1">Dimensions</div>
                  <div className="text-sm font-semibold text-white break-words">{selectedProduct.size}</div>
                </div>
                <div className="bg-gray-800/40 border border-gray-500/20 rounded-xl p-4 text-center">
                  <i className="ri-layout-grid-line text-2xl text-gray-300 mb-2"></i>
                  <div className="text-xs text-gray-400 mb-1">Floor Area</div>
                  <div className="text-sm font-semibold text-white">{selectedProduct.area}</div>
                </div>
                <div className="bg-gray-800/40 border border-gray-500/20 rounded-xl p-4 text-center">
                  <i className="ri-group-line text-2xl text-gray-300 mb-2"></i>
                  <div className="text-xs text-gray-400 mb-1">Capacity</div>
                  <div className="text-sm font-semibold text-white break-words">{selectedProduct.capacity}</div>
                </div>
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <Link
                  to={`/contact?product=${encodeURIComponent(selectedProduct.name)}`}
                  className="flex-1 px-8 py-4 bg-gray-300 text-black text-base font-medium rounded-full hover:bg-gray-200 transition-all hover:shadow-[0_0_30px_rgba(148,163,184,0.6)] whitespace-nowrap cursor-pointer text-center"
                >
                  Request Quote
                </Link>
                <button
                  onClick={closeModal}
                  className="flex-1 px-8 py-4 bg-gray-800/60 border border-gray-500/30 text-white text-base font-medium rounded-full hover:bg-gray-700/60 hover:border-gray-400/50 transition-all whitespace-nowrap cursor-pointer"
                >
                  Continue Browsing
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
